import React from 'react';
import { useSelector } from "react-redux"
import Select from 'react-select';
import { useTranslation } from 'react-i18next';


export const MCSelect = ({ options, onChange = () => {}, menuWidth=null, optionLabel = "label", optionValue = "value", isValid = true, ...rest }) => {
    const { gTheme } = useSelector(state => state.theme);
    const [t] = useTranslation("components")

    // Función para remover números del inicio del label (ej: "01 Zapata" -> "Zapata")
    const removeLeadingNumbers = (label) => {
        if (typeof label !== 'string') return label;
        return label.replace(/^\d+\s+/, '');
    };

    // Función para ordenar y formatear opciones
    const sortedOptions = React.useMemo(() => {
        if (!options || !Array.isArray(options)) return options;

        return [...options].sort((a, b) => {
            const labelA = a[optionLabel] || '';
            const labelB = b[optionLabel] || '';
            return labelA.localeCompare(labelB, undefined, { numeric: true, sensitivity: 'base' });
        });
    }, [options, optionLabel]);

    // Función para formatear el label mostrado (sin números)
    const formatOptionLabel = (option) => {
        const label = option[optionLabel];
        return removeLeadingNumbers(label);
    };

    return (
        <Select
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    border: !isValid ? "solid 1px #f5425a" : gTheme === "light" ? "solid 1px #e3ebf5" : "solid 1px #363742",
                    backgroundColor: gTheme === "light" ? "#fff" : "#242836",
                    filter: state.isDisabled ? "contrast(90%)" : "none"
                }),
                option: (provided, state) => ({
                    ...provided,
                    color: state.isSelected ? state.isFocused ? gTheme === "light" ? "#000000" : "#bdcad0 !important" : '#00000 !important' : gTheme === "light" ? "#78909c !important" : "#bdcad0 !important",
                    background: state.isFocused ? gTheme === "light" ? "#e6ebef" : "#32384d" : '#ffff',
                }),
                input: (provided, state) => ({
                    ...provided,
                    // color: gTheme === "light" ? "#324148 !important" : "#b0bec5 !important",
                    color: !isValid ? "#f5425a" : gTheme === "light" ? "#324148 !important" : "#b0bec5 !important"
                }),
                singleValue: (styles, { data }) => ({
                    ...styles,
                    // color: gTheme === "light" ? "#324148 !importtant" : "#b0bec5 !important",
                    color: !isValid ? "#f5425a" : gTheme === "light" ? "#324148 !important" : "#b0bec5 !important"
                }),
                multiValue: (styles) => ({
                    ...styles,
                    backgroundColor: gTheme === "light" ? "#e3ebf5" : "#363742",
                }),
                multiValueLabel: (styles) => ({
                    ...styles,
                    color: gTheme === "light" ? "#324148" : "#b0bec5",
                }),
                multiValueRemove: (styles) => ({
                    ...styles,
                    color: gTheme === "light" ? "#324148" : "#b0bec5",
                    ':hover': {
                        backgroundColor: gTheme === "light" ? "#d0d8de" : "#4a5064",
                        color: gTheme === "light" ? "#324148" : "#fff",
                    },
                }),
                placeholder: (provider, state) => ({
                    ...provider,
                    // color: gTheme === "light" ? "#324148 !important" : "#b0bec5 !important",
                    color: !isValid ? "#de463d" : gTheme === "light" ? "#324148 !important" : "#b0bec5 !important"                    
                }),
                menu: (provided, state) => ({
                    ...provided,
                    backgroundColor: gTheme === "light" ? "#fff" : "#242836",
                    minWidth: "100%",
                    ...(!isNaN(menuWidth) && { width: menuWidth }),
                }),
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                ...(!isValid && {
                    indicatorSeparator: (provided, state) => ({
                        ...provided,
                        backgroundColor: "#f5425a", // Cambia esto al color que desees
                    }),
                    dropdownIndicator: (provided, state) => ({
                        ...provided,
                        color: "#f5425a", // Cambia esto al color que desees
                    }),
                })
            }}
            placeholder={t("MCSelect.select_option")}
            options={sortedOptions}
            onChange={(e) => onChange(e)}
            getOptionLabel ={(option)=>option[optionLabel]}
            getOptionValue ={(option)=>option[optionValue]}
            formatOptionLabel={formatOptionLabel}
            {...rest}
        />
    );
}